import store from '@/store';
import { computed, onMounted, onUnmounted } from 'vue';
const useScheduleTemplates = () => {
    onMounted(() => store.dispatch.scheduleTemplates.subscribe());
    onUnmounted(() => store.dispatch.scheduleTemplates.unsubscribe());
    return {
        scheduleTemplates: computed(() => store.state.scheduleTemplates.templates),
        createScheduleTemplate: store.dispatch.scheduleTemplates.create,
        deleteScheduleTemplate: store.dispatch.scheduleTemplates.delete,
        updateScheduleTemplate: store.dispatch.scheduleTemplates.update
    };
};
export default useScheduleTemplates;
